// extracted by mini-css-extract-plugin
module.exports = {"policy":"bc_bT","underline":"bc_bV","thanksTitle":"bc_cT"};